<template>
  <div>
    <van-popup overlay-class="pop-login" class="box-login" v-model="visible" :close-on-click-overlay="false" closeable close-icon="close" @closed="onClosed">
      <div class="qr-wrapper">
        <div class="qr-title">微信安全登录</div>
        <div class="qr-box">
          <img v-if="qrcodeUrl" :src="qrcodeUrl" alt="" />
        </div>
        <div class="qr-tip">关注 "立吉投票" 服务号完成注册</div>
        <div class="qr-tip">扫码注册后代表您阅读并同意<span @click="toAgreement">《用户协议》</span></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import router from "@/router/index";
import http from "@/utils/request";
import api from "@/utils/api";
import { getToken, isMobile, handleZI } from "@/utils/common";

export default {
  name: "AuthGate",
  data() {
    return {
      visible: false,
      qrcodeUrl: "",
      pollingTimer: null,
      currentParams: {},
      pollingCount: 0, // 轮询计数器
      maxPollingAttempts: 20, // 最大轮询次数
    };
  },
  methods: {
    launch(params = {}) {
      this.currentParams = params || {};
      if (isMobile()) {
        this.openSchemaLink();
      } else {
        this.visible = true;
        this.fetchQrCode()
      }
    },
    // 移动端唤起小程序schema链接
    openSchemaLink() {
      const query = {
        type: 1,
        path: 'pages/detail/detail',
        scene: this.currentParams.vid || ''
      };
      http
        .get(api.lotto.getSchema, query)
        .then((res) => {
          if (res && res.sta === 0 && res.data && res.data.scheme) {
            window.location.href = res.data.scheme;
          }
        })
        .catch(() => {});
    },
    // 桌面端获取登录二维码
    fetchQrCode() {
      const timestamp = new Date().getTime();
      const myToken = timestamp + Math.ceil(Math.random() * 1000000000000000) + "";
      const query = {
        token: myToken
      };
      this.pollingCount = 0;
      return http
        .get(api.lotto.getQrCode, query)
        .then((res) => {
          if (res && res.sta === 0 && res.data && res.data.qrcode) {
            this.qrcodeUrl = res.data.qrcode;
            this.startPolling(myToken);
          }
        })
        .catch(() => {});
    },
    startPolling(myToken) {
      this.clearPolling();
      this.pollingTimer = setInterval(() => {
        this.pollingCount++;

        // 如果达到最大轮询次数，自动刷新二维码
        if (this.pollingCount >= this.maxPollingAttempts) {
          this.fetchQrCode();
          return;
        }

        const query = { token: myToken };
        http
          .get(api.lotto.checkStatus, query)
          .then((res) => {
            if (res && res.sta === 0) {
              this.onAuthed(res);
            }
          })
          .catch(() => {});
      }, 3000);
    },
    clearPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
      }
    },
    onAuthed(res) {
      this.visible = false;
      this.clearPolling();
      localStorage.setItem('token', res.data.access_token);
      handleZI(res.data.mp_openid);
      window.location.reload();
    },
    onClosed() {
      this.clearPolling();
    },
    toAgreement() {
      router.push({
        path: "/agreement"
      });
    },
  },
  beforeDestroy() {
    this.clearPolling();
  },
};
</script>

<style scoped>
.box-login {
  width: 350px;
  border-radius: 8px;
}
.qr-wrapper {
  padding: 20px 16px 24px;
  text-align: center;
  background: #fff;
}
.qr-title {
  font-size: 24px;
  color: #333333;
  text-align: center;
  line-height: 60px;
}
.qr-tip {
  margin-top: 6px;
  font-size: 14px;
  color: #666;
}
.qr-tip span {
  color: #1890ff;
}
.qr-box {
  margin: 20px auto;
  width: 200px;
  height: 200px;
}
.qr-box img {
  display: block;
  width: 200px;
  height: 200px;
  margin: 0 auto;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/common/authGate.vue